import Joi from "joi-browser";


export const initJoi = () => {
  Joi.addLocaleData("es_DO", {
    number: {
      // using joi's template syntax
      required: `"{{key}}" is requerido`,
    },
    string: {
      // using joi's template syntax
      required: `"{{key}}" is requerido`,
    },
  });
};

const parseFunc = {
  min: parseInt,
  max: parseInt,
};

const parse = (key, value) => {
  if (!parseFunc[key]) return value;

  return parseFunc[key](value);
};

export const createJoiValidationChain = (validation) => {
  let fluent;

  validation.split("=>").map((v) => {
    let func = v;
    let arg = v.match(/\(([^)]+)\)/);
    if (arg) {
      func = v.split("(")[0];
      arg = arg[1];
    }
    if (!fluent) fluent = arg ? Joi[func](parse(func, arg)) : Joi[func]();
    else fluent = arg ? fluent[func](parse(func, arg)) : fluent[func]();
  });

  return fluent;
};
